/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import { Logo, LogoPCTP } from '@weirgroup/one-weir';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import styles from './globalHeader.module.css';
import UserLight from '../../resources/images/UserLight.svg';
import FlyoutMenu from '../flyoutMenu';
import LanguageSelection from '../LanguageSelection/LanguageSelection';

/* 
GlobalHeaderComponent  and infomodal popup, this uses i18n for the text content.
*/

export default function GlobalHeader(props) {
  const { t } = useTranslation();
  const [FlyoutMenustate, setpopup] = useState(false);

  function handleFlyout(menustate) {
    setpopup(menustate);
  }
  function renderGlobalHeader() {
    const { storeLanguageCode, languageCode, isAuthenticated } = props;
    if (isAuthenticated) {
      return (
        <div className={styles.navContainer}>
          <div data-testid="logo" className={styles.logo}>
            <Logo white />
            {FlyoutMenustate ? <FlyoutMenu onClick={handleFlyout} /> : null}
          </div>

          <div data-testid="navheadertext" className={styles.navheaderText}>
            {t('navheaderText')}
          </div>
          <LanguageSelection
            color="white"
            storeLanguageCode={storeLanguageCode}
            languageCode={languageCode}
          />
          <div
            data-testid="userIcon"
            className={styles.userIcon}
            role="link"
            tabIndex="0"
            onClick={() => {
              setpopup(!FlyoutMenustate);
            }}
          >
            <img src={UserLight} alt={t('altUserIcon')} />
          </div>
        </div>
      );
    }
    return (
      <div className={styles.loginHeader}>
        <div data-testid="logo" className={styles.logo}>
          <LogoPCTP height={50} width={100} blue />
        </div>
        <LanguageSelection
          color="blue"
          storeLanguageCode={storeLanguageCode}
          languageCode={languageCode}
        />
      </div>
    );
  }

  return <div>{renderGlobalHeader()}</div>;
}
GlobalHeader.propTypes = {
  languageCode: PropTypes.string.isRequired,
  storeLanguageCode: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
};
